<template>
    <div v-if="showCriticalModal && $store.getters.hasGatehousePerm('view_notification')" class="critical_modal_backdrop">
        <div class="critical_modal">
            <h2 class="text-danger fw-bold">{{ $t("notifications.modalTitle") }}</h2>

            <ul v-if="criticalNotifications.length > 0" class="list-unstyled text-start mt-3">
                <li v-for="notification in criticalNotifications"
                    :key="notification.id"
                    class="mb-3 p-3 border rounded bg-light">

                    <strong>{{ notification.gatehouse_name }}</strong><br>
                    <strong>{{ notification.message }}</strong><br>
                    {{ $t("notifications.device") }}: {{ notification.device_name }}<br>
                    {{ $t("notifications.created") }}: {{ notification.created_at ? $d(new Date(notification.created_at), "short") : "-" }}

                    <div class="text-end mt-2">
                    <button class="btn btn-primary btn-sm"
                        @click="openEvent(notification)">
                        {{ $t("utils.open") }}
                    </button>
                    </div>
                </li>
            </ul>

            <div class="text-end mt-4">
                <button class="btn btn-danger" @click="showCriticalModal = false">
                    {{ $t("utils.close") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            intervalId: null,
            showCriticalModal: false,
            criticalNotifications: [],
        }
    },
    computed: {
        selectedGatehouse() {
            return this.$store.getters.selectedGatehouse;
        },
        currentSlug() {
            return this.$route.params.slug || null;
        }
    },
    methods: {
        startPolling() {
            if (!this.$store.getters.hasGatehousePerm('view_notification')) {
                return;
            }

            const api = this.$store.getters.api;

            const fetchData = () => {
                api.get(`/dashboard/${this.currentSlug}/notifications/critical-global`)
                .then(res => {
                    if (res.data.critical) {
                        this.criticalNotifications = res.data.notifications;
                        this.showCriticalModal = true;
                    } else {
                        this.criticalNotifications = [];
                        this.showCriticalModal = false;
                    }
                })
                .catch(error => {
                    console.error("Error loading critical notifications", error);
                });

                api.get(`/dashboard/${this.currentSlug}/notifications/unresolved-count`)
                .then(res => {
                    const newCount = res.data.count;
                    const oldCount = this.$store.state.lastNotificationCount;

                    if (newCount !== oldCount) {
                        this.$store.commit("setNotificationCount", newCount);
                        this.$store.state.lastNotificationCount = newCount;
                    }
                });
            };

            fetchData();
            this.intervalId = setInterval(fetchData, 10000);
        },
        openEvent(notification) {
            this.showCriticalModal = false;
            this.$router.push(`/dashboard/${notification.gatehouse_slug}/notifications`);
        },
    },
    watch: {
        currentSlug(slug) {
            if (slug && this.intervalId === null) {
                this.startPolling();
            }
        }
    }
}
</script>

<style scoped>
.critical_modal_backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.critical_modal {
    background: white;
    padding: 40px;
    border-radius: 15px;
    width: 500px;
    text-align: center;
    animation: pulseBorder 1s infinite;
}

@keyframes pulseBorder {
    0%   { box-shadow: 0 0 0 0 rgba(220,53,69,0.8); }
    100% { box-shadow: 0 0 70px 40px rgba(220,53,69,0); }
}
</style>